import React from 'react'
import Meta from '../components/core/Meta'
import { OnExitPopup } from './components/on-exit-popup'
import { OnloadPopups } from './components/onload-popups'
import { TriggeredPopup } from './components/triggered-popup'
import PageUi from './ui/PageUi'

export interface WebsitePageProps {
  noIndex?: boolean
  children: React.ReactNode
}

export const WebsitePage = ({
  children,
  noIndex = false,
}: WebsitePageProps) => {
  return (
    <PageUi>
      <Meta noIndex={noIndex} />
      {children}
      <TriggeredPopup />
      <OnExitPopup />
      <OnloadPopups />
    </PageUi>
  )
}
